{
  "version": "2.5.43",
  "commitHash": "295880cdc9ba8b1ee137703efab274cc0afaf793",
  "commitShortHash": "295880cd",
  "branchName": "purchase-order-stock-in",
  "commitDate": "2026-11-05T14:25:50+01:00"
}
